var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "arrow-left_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#arrow-left_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M13.473 17.127 8.98 12.633a.818.818 0 0 1-.198-.301.974.974 0 0 1-.058-.332.829.829 0 0 1 .256-.633l4.494-4.494A.717.717 0 0 1 14 6.656c.206 0 .382.072.527.217.145.145.217.32.217.527a.717.717 0 0 1-.217.527L10.454 12l4.073 4.073c.145.145.217.32.217.527a.718.718 0 0 1-.217.527.717.717 0 0 1-.527.217.717.717 0 0 1-.527-.217Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowLeft;